import React from 'react';
import { OrbitComponent } from '../base-components/orbit-component/orbit-component';
import {observer} from "mobx-react";
import {LinkToOfferIconBox} from "./boxes/link-to-offer-icon/link-to-offer-icon.box";
import {LinkToOfferDialogCloseBox} from "./boxes/link-to-offer-dialog-close/link-to-offer-dialog-close.box";
import {LinkToOfferConfiguration} from "../../services/configurations/config-data-sections/link-to-offer.configuration";
import { IOffer } from '../../services/player-offerings/player-offerings.service';
import { IShowOfferOptions } from '../../services/player-offerings/player-offerings.service.interface';

export interface LinkToOfferComponentProps {
    linkToOfferConfig: LinkToOfferConfiguration;
}


@observer
export class LinkToOfferComponent extends OrbitComponent<LinkToOfferComponentProps> {

    componentDidMount() {
        super.componentDidMount();
        this.services.playerOfferings.setWelcomeOfferConfig(this.props.linkToOfferConfig?.welcomeBonus ?? null);
    }

    render() {
        if (this.services.playerOfferings.hasOpenedPopup) {
            let CloseIconComponent = this.services.theme.currentTheme.icons.linkToOfferCloseIcon;

            return (
                <LinkToOfferDialogCloseBox className={'cy-link-to-offer-dialog-close-box'}
                                           onClick={() => {this._onCloseDialog()}}
                                           shouldAnimate={false}
                                           hasCircle={true}
                                           zIndex={this.services.playerOfferings.isHighPriorityOffer ? this.services.dialog.getMaxCGPOverlayZIndex() + 2: null}
                                           isHybridEmbedded={this.services.device.hybrid.isEmbedded}
                >
                    <CloseIconComponent size={2} sizeIsHeight />
                </LinkToOfferDialogCloseBox>
            );
        }

        const currentOffer = this.services.playerOfferings.currentLinkToOffer;
        if(!currentOffer) {
            return null;
        }

        return (
            <LinkToOfferIconBox className={'cy-link-to-offer-icon-box'}
                                onClick={() => {this._onLinkToOfferClicked(currentOffer)}}
                                shouldAnimate={currentOffer.shouldUseLinkToOfferAnimation()}
                                hasCircle={currentOffer.shouldUseLinkToOfferAnimation()}
                                isHybridEmbedded={this.services.device.hybrid.isEmbedded}
            >
                { currentOffer.render() }
            </LinkToOfferIconBox>
        );
    }


    private _onLinkToOfferClicked(offer: IOffer): void {

        this.services.analytics.sendAnalytics(offer.analyticsCategory, this.services.routing.currentRoute.data.arenaType, 'Open_Floating_Button');

        const options: IShowOfferOptions = {
            onPopupClosed: () => {
                this.services.analytics.sendAnalytics(offer.analyticsCategory, this.services.routing.currentRoute.data.arenaType, 'Close_Floating_Button');
            }
        };
        this.services.playerOfferings.showOfferPopup(offer, options);
    }

    private _onCloseDialog = () => {
        if (this.services.playerOfferings.hasOpenedPopup) {
            this.services.playerOfferings.closeCurrentPopup();
        }
    };
}
